import {customSettings} from '../../../../../../../ndstemplate/Resources/Public/Assets/Js/Settings/customSettings.js';

function initPagescroll(customSettings) {
	let last_known_scroll_position = 0,
		ticking = false,
		el = document.body;

	const defaultSettings = {
		threshold: 10,
		className: 'is-scrolled'
	};

	const settings = extend({}, defaultSettings, customSettings.pagescroll);

	function isScrolled(scrollpos) {
		if (scrollpos > settings.threshold) {
			el.classList.add(settings.className);
		} else {
			if (el.classList.contains(settings.className)) {
				el.classList.remove(settings.className);
			}
		}
	}

	window.addEventListener('scroll', function (e) {
		last_known_scroll_position = window.pageYOffset;

		if (!ticking) {
			window.requestAnimationFrame(function () {
				isScrolled(last_known_scroll_position);
				ticking = false;
			});

			ticking = true;
		}
	});
	isScrolled(window.pageYOffset);
}

initPagescroll(customSettings);
